import { FC } from "react";

import { BestPracticeSvgLogoProps } from "@bps/fluent-ui";

interface NavBarLogoProps extends Omit<BestPracticeSvgLogoProps, "isBlue"> {
  red?: boolean;
}
export const NavBarLogo: FC<NavBarLogoProps> = ({ red, ...logoProps }) => {
  const colour = red ? "#E18F8B" : "#9BC5DA";

  return (
    <svg
      {...logoProps}
      width="22"
      height="32"
      viewBox="0 0 22 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="15" r="3" fill="white" />
      <circle cx="11" cy="15" r="3" fill="#9BC5DA" />
      <circle cx="5" cy="23" r="3" fill={colour} />
      <circle cx="17" cy="7" r="3" fill="white" />
    </svg>
  );
};
